module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_wollerau-aff7888f7664d80c2eb7d22ea13d25a9.png";